import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Explore.css";

const Explore = ({
  placeholderText = "Explore Page (Coming Soon)",
  title = "Explore Content",
}) => {
  const location = useLocation();
  const iframeUrl = location.state?.url;

  // Hide header categories when iframe is loaded
  useEffect(() => {
    if (iframeUrl) {
      document.body.classList.add("iframe-loaded");
    } else {
      document.body.classList.remove("iframe-loaded");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("iframe-loaded");
    };
  }, [iframeUrl]);

  return (
    <div className="explore-page">
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          className="explore-iframe"
          title={title}
          allowFullScreen
          allow="microphone"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      ) : (
        <div className="explore-content">
          <div style={{ padding: "20px", textAlign: "center" }}>
            {placeholderText}
          </div>
        </div>
      )}
    </div>
  );
};

export default Explore;
